import PropTypes from "prop-types"
import React from "react"
import { Link } from 'gatsby'
import logo from '../images/udevs_logo.svg'
import usaFlag from '../images/usa-flag.svg';
import ruFlag from '../images/ru-flag.svg';

const Header = ({ siteTitle, lang }) => (
  <header>
    <div className="logo">
      <img src={logo} alt={siteTitle} title="UDevs" />
      {/* <div className="logo__text"> - software development <br/> company located in Tashkent</div> */}
      <div className="nav-item dropdown">
        <span className="at-left">
          <img src={lang === 'en' ? usaFlag : ruFlag} alt="select language" />
        </span>
        <div className="dropdown-content">
          <Link to="/en">
            <img src={usaFlag} alt="USA flag" />
            <span className="lang-dark">English</span>
          </Link>
          <Link to="/">
            <img src={ruFlag} alt="RU flag" />
            <span className="lang-dark">Русский</span>
          </Link>
        </div>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
